module.exports = __webpack_public_path__ + "static/media/passport-front.84823e4e.png";